import {PaymentDiscriminator} from '@dms/api/sales';

/**
 * Whether the external accounting system owns the payment — the counterpart of the backend
 * Checkout::isOrderPaymentAccountedExternally. A purchase stays local under external accounting:
 * issued and paid as without it, only without a local cash register document.
 */
export const isPaymentAccountedExternally = (
  canCreateExternalCheckoutDocuments: boolean,
  paymentDiscriminator: PaymentDiscriminator
) => canCreateExternalCheckoutDocuments && paymentDiscriminator !== 'PURCHASE';
